import React from 'react'

import Base from '../_Base'

const AuMa = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M24 21.9975C24 23.0983 23.0981 24 22.0014 24H1.99859C0.897671 24 0 23.0983 0 21.9975V1.99824C0 0.897513 0.897671 0 1.99859 0H22.0014C23.1023 0 24 0.897513 24 1.99824V21.9975Z"
      fill="white"
    />
    <path
      d="M22.907 21.0902C22.907 22.0908 22.0872 22.9106 21.0905 22.9106H2.90957C1.90893 22.9106 1.09302 22.0908 1.09302 21.0902V2.90932C1.09302 1.90868 1.90893 1.09277 2.90957 1.09277H21.0905C22.0911 1.09277 22.907 1.90868 22.907 2.90932V21.0902Z"
      fill="#ED1C24"
    />
    <path
      d="M16.3291 13.5583V10.3619L15.655 10.955V10.539L16.3291 9.95752H16.695V13.5583H16.3291Z"
      fill="white"
    />
    <path
      d="M19.0024 13.3273C18.8367 13.4929 18.6018 13.593 18.286 13.593C17.9701 13.593 17.7197 13.4929 17.5618 13.335C17.4039 13.1732 17.3307 12.9653 17.3076 12.7073H17.6735C17.7198 13.0654 17.9046 13.2695 18.286 13.2695C18.4631 13.2695 18.6249 13.2079 18.7327 13.1039C18.9215 12.9191 18.9292 12.6302 18.9292 12.3722C18.9292 11.9332 18.8444 11.498 18.3206 11.498C18.0086 11.498 17.7968 11.6405 17.7236 11.8523H17.3962V9.96143H19.2181V10.2849H17.7275V11.4287C17.87 11.2708 18.0934 11.1822 18.3745 11.1822C18.6557 11.1822 18.856 11.2669 18.9985 11.4094C19.2604 11.6713 19.2951 12.0372 19.2951 12.3761C19.2951 12.7342 19.2643 13.0731 19.0062 13.3311L19.0024 13.3273Z"
      fill="white"
    />
    <path
      d="M20.9858 12.3763V13.2661H20.6468V12.3763H19.7571V12.0374H20.6468V11.1592H20.9858V12.0374H21.8717V12.3763H20.9858Z"
      fill="white"
    />
    <path
      d="M7.76673 14.3168V11.5517L6.86158 13.3502H6.2376L5.32475 11.5517V14.3168H4.39648V9.57227H5.30934L6.54959 12.1371L7.78214 9.57227H8.69499V14.3168H7.76673Z"
      fill="white"
    />
    <path
      d="M12.1885 14.3168L11.9074 13.4773H10.2203L9.93528 14.3168H8.96851L10.6941 9.57227H11.4182L13.1515 14.3168H12.1847H12.1885ZM11.0831 10.9702L10.4861 12.6955H11.6647L11.0831 10.9702Z"
      fill="white"
    />
    <path
      d="M12.0461 7H5.20157L2.14331 11.9024L5.20157 16.8087H12.1308L15.189 11.9024L12.1308 7H12.0461ZM11.9613 7.30809C12.0461 7.44673 14.7307 11.7522 14.827 11.9063C14.7307 12.0603 12.0461 16.3659 11.9613 16.5045H5.37104C5.28631 16.3659 2.60166 12.0603 2.50537 11.9063C2.60166 11.7522 5.28631 7.44673 5.37104 7.30809H11.9613Z"
      fill="white"
    />
  </Base>
)

export default AuMa
